/* Gatsby Browser API
 * -------------------
 * The file gatsby-browser.js lets you respond to Gatsby-specific events within
 * the browser, and wrap your page components in additional global components.
 * The Gatsby Browser API gives you many options for interacting with the
 * client-side of Gatsby.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

import React from "react";
import { ThemeProvider } from "./src/context/ThemeContext";
import { Link } from "gatsby";
import { PrismicProvider } from "@prismicio/react";
import { linkResolver } from "./src/utilities/prismic-linkResolver.js";
import { richTextComponents } from "./src/components/common/PrismicRichText";

export const wrapPageElement = ({ element, props }) => {
  return <ThemeProvider pageData={props.data}>{element}</ThemeProvider>;
};

export const onClientEntry = () => {
  const searchParams = new URLSearchParams(window.location.search);
  if (searchParams.size > 0) {
    window.sessionStorage.setItem("utm_href", window.location.href);
  }

  const hostname = window.location.hostname;
  const isPreview = hostname.endsWith('.pages.dev');
  if (!isPreview) return;

  const password = process.env.GATSBY_PREVIEW_PASSWORD;
  if (!password) {
    return;
  }

  const entered = sessionStorage.getItem("auth");

  if (entered !== "ok") {
    const input = prompt("Enter password:");
    if (input === password) {
      sessionStorage.setItem("auth", "ok");
    } else {
      alert("Wrong password!");
      window.location.reload();
    }
  }
};

export const wrapRootElement = ({ element }) => (
  <PrismicProvider
    linkResolver={linkResolver}
    richTextComponents={richTextComponents}
    internalLinkComponent={({ href, ...props }) => (
      <Link to={href} {...props} />
    )}
  >
    {element}
  </PrismicProvider>
);
